var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 828,
    viewBox: "0 0 600 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 241,
    width: 157,
    height: 389,
    rx: 78.5,
    fill: "#F1F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.001 228.001C242.045 228.001 194.892 275.154 194.892 333.11V539.687C194.892 597.636 242.045 644.789 300.001 644.789C357.958 644.789 405.11 597.964 405.11 540.409V333.11C405.11 275.154 357.958 228.001 300.001 228.001ZM361.308 540.403C361.308 573.805 333.804 600.987 300.001 600.987C266.199 600.987 238.688 573.49 238.688 539.68V333.11C238.688 299.3 266.192 271.796 300.001 271.796C333.811 271.796 361.315 299.3 361.308 333.11V540.403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.896 707.561H278.101V806.101H321.896V707.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.665 784.207H242.336C230.242 784.207 220.439 794.01 220.439 806.105C220.439 818.2 230.242 828.002 242.336 828.002H357.665C369.76 828.002 379.563 818.2 379.563 806.105C379.563 794.01 369.76 784.207 357.665 784.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.692 503.18C453.597 503.18 443.794 512.982 443.794 525.077V542.596C443.794 621.88 379.283 686.392 299.998 686.392C220.707 686.392 156.202 621.881 156.202 542.596V525.077C156.202 512.982 146.399 503.18 134.304 503.18C122.209 503.18 112.406 512.982 112.406 525.077V542.596C112.406 646.034 196.56 730.187 299.998 730.187C403.436 730.187 487.589 646.034 487.589 542.596V525.077C487.589 512.984 477.787 503.18 465.692 503.18Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.989 162.573C460.305 161.581 460.659 159.713 459.768 158.377C441.051 130.287 416.545 107.24 388.146 91.0434C358.938 74.3848 326.447 65.4478 293.344 64.9673C260.241 64.4867 227.472 72.4764 197.732 88.2792C168.826 103.639 143.584 125.954 123.959 153.475C123.008 154.808 123.234 156.637 124.453 157.616L133.198 164.635C134.503 165.683 136.432 165.351 137.454 163.926C155.472 138.793 178.593 118.407 205.048 104.35C232.421 89.8045 262.582 82.4506 293.05 82.8929C323.519 83.3352 353.425 91.5611 380.308 106.894C406.34 121.741 428.818 142.841 446.018 168.551C446.945 169.936 448.815 170.242 450.18 169.214L458.989 162.573Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.849 198.067C426.165 197.075 426.519 195.207 425.624 193.873C410.824 171.822 391.512 153.722 369.159 140.973C345.996 127.762 320.23 120.675 293.978 120.294C267.727 119.913 241.741 126.249 218.157 138.781C195.406 150.87 175.518 168.392 160.005 189.99C159.05 191.32 159.276 193.149 160.495 194.128L166.483 198.934C167.788 199.982 169.716 199.65 170.744 198.229C184.977 178.547 203.169 162.572 223.958 151.525C245.665 139.991 269.583 134.159 293.746 134.51C317.908 134.86 341.624 141.384 362.943 153.543C383.411 165.216 401.108 181.764 414.702 201.916C415.633 203.297 417.504 203.604 418.868 202.575L424.849 198.067Z",
    fill: "#030303"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white",
    transform: "translate(0 228.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.8fb393ff9dc8b5d6ed6f77133c4641ef.svg";
export { ForwardRef as ReactComponent };